import { Navigate, Route, Routes } from 'react-router-dom'
import AddListInspectionTemplate from './pages/InspectionTemplate/AddListInspectionTemplate/AddInspectionTemplate'
import ListInspectionTemplate from './pages/InspectionTemplate/ListInspectionTemplate/ListInspectionTemplate'
import OrderTemplates from './pages/OrderTemplates/OrderTemplates'
import TimeActionTemplates from './pages/TimeActionTemplates/TimeActionTemplate'

export default function TemplateRoutes() {
  return (
    <Routes>
      <Route path="" element={<Navigate to={'inspection-template'} />} />
      <Route path="inspection-template" element={<ListInspectionTemplate />} />
      <Route path="order-template" element={<OrderTemplates />} />
      <Route path="time-action-template" element={<TimeActionTemplates />} />
      <Route
        path="add-inspection-template"
        element={<AddListInspectionTemplate />}
      />
      <Route
        path="edit-inspection-template/:key"
        element={<AddListInspectionTemplate />}
      />
    </Routes>
  )
}
